import React, { useEffect, useState } from 'react'
import { Colors } from '../color'
import RightArrow from '../assets/images/right_arrow.png'
import { FaArrowRightLong } from "react-icons/fa6";
import Categories from '../components/Categories';
import { Featured, Tranding } from '../constants/LocalData';
import OwlSlider from '../view/customSlider';
import { Link, NavLink } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useDispatch, useSelector } from 'react-redux';
import { getHomeData, getpostlist } from '../redux/actions/action-creator';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Spinner from '../view/customSpinner/Spinner3';
import Spinner4 from '../view/customSpinner/Spinner4';
import Spinner3 from '../view/customSpinner/Spinner3';


const Home = () => {
    const dispatch = useDispatch();

    const { homeCategryList = [] } = useSelector(state => state.common);



    const homeSlider1 = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    speed: 300,
                    slidesToShow: 1,
                    variableWidth: true
                }
            }
        ]
    };

    const homeSlider2 = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    speed: 300,
                    slidesToShow: 2,
                    variableWidth: true
                }
            }
        ]
    };

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        API_Function();
    }, []);

    const API_Function = () => {
        dispatch(getpostlist())
            .then(response => {
                if (response?.success) {
                    setIsLoading(false); // Set isLoading to false once data is fetched
                } else {
                    // Handle error if needed
                }
            })
            .catch(error => {
                // Handle error if needed
            });
    };


    return (
        <>
            <Categories />
            <style>{`
               .main_container.responsiveClose main {
                padding: 0 50px;
            }
            `}</style>

            {/* <Spinner3 /> */}
            <div className='Featured_Category' >
                {homeCategryList?.cat_data?.map((category, categoryIndex) => (
                    <div key={categoryIndex}>
                        <div className='Featured_Category_heading_flex'>
                            <div>
                                <h2>{category.name ? category.name : <Skeleton width={200} />} {/* Skeleton for category name */}
                                    <span className='resp_buton_wer' style={{ display: 'none' }}>
                                        <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER }}>
                                            <NavLink to='/FeaturedDetails'>
                                                <span>View all</span>
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4 11.75C3.80109 11.75 3.61032 11.829 3.46967 11.9697C3.32902 12.1103 3.25 12.3011 3.25 12.5C3.25 12.6989 3.32902 12.8897 3.46967 13.0303C3.61032 13.171 3.80109 13.25 4 13.25V11.75ZM4 13.25H20V11.75H4V13.25Z" fill="#0D0D0D" />
                                                    <path d="M14 6.5L20 12.5L14 18.5" stroke="#0D0D0D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </NavLink>
                                        </button>
                                    </span>
                                </h2>
                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                            </div>
                            <div className='testop_buton_wer'>
                                <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER }}>
                                    <NavLink to='/FeaturedDetails'>
                                        <span>View all</span>
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 11.75C3.80109 11.75 3.61032 11.829 3.46967 11.9697C3.32902 12.1103 3.25 12.3011 3.25 12.5C3.25 12.6989 3.32902 12.8897 3.46967 13.0303C3.61032 13.171 3.80109 13.25 4 13.25V11.75ZM4 13.25H20V11.75H4V13.25Z" fill="#0D0D0D" />
                                            <path d="M14 6.5L20 12.5L14 18.5" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </NavLink>
                                </button>
                            </div>
                        </div>
                        <div className='Featured_Category_grid'>
                            {categoryIndex === 1 ? (
                                isLoading ? (
                                    <Spinner4 />
                                ) : (
                                    category?.blogs_data ? (
                                        <Slider {...homeSlider2} className='homeslider second_home_sleder responsive_home_slider_2'>
                                            {category.blogs_data.map((item, index) => (
                                                <Link to='/Comment' className='Category_card' key={index}>
                                                    <img src={item?.thumbnail_image} alt={item.title} />
                                                    <div className='Category_card_post_flex'>
                                                        <div className='Category_img_grid'>
                                                            <img src={item?.userprofile} alt={`${item.username}'s profile`} />
                                                        </div>
                                                        <div>
                                                            <h2>{item.title}</h2>
                                                            <p>
                                                                <span>{item.username}</span>
                                                                <span>{item.view_count} views</span>
                                                            </p>
                                                        </div>
                                                        <ul>
                                                            {item.tags.length > 0 ? (
                                                                item.tags.map((tag, tagIndex) => (
                                                                    <li key={tagIndex}>{tag.tag_name}</li>
                                                                ))
                                                            ) : (
                                                                <li>No tags available</li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </Link>
                                            ))}
                                        </Slider>
                                    ) : null
                                )
                            ) : categoryIndex === 2 ? (
                                isLoading ? (
                                    <Spinner3 />
                                ) : (
                                    category?.blogs_data ? (
                                        <Slider {...homeSlider1} className='homeslider tred_slider_home responsive_home_slider'>
                                            {category.blogs_data.map((item, index) => (
                                                <Link to='/Comment' className='Category_card' key={index}>
                                                    <img src={item?.thumbnail_image} alt={item.title} />
                                                    <div className='Category_card_post_flex'>
                                                        <div className='Category_img_grid'>
                                                            <img src={item?.userprofile} alt={`${item.username}'s profile`} />
                                                        </div>
                                                        <div>
                                                            <h2>{item.title}</h2>
                                                            <p>
                                                                <span>{item.username}</span>
                                                                <span>{item.view_count} views</span>
                                                            </p>
                                                        </div>
                                                        <ul>
                                                            {item.tags.length > 0 ? (
                                                                item.tags.map((tag, tagIndex) => (
                                                                    <li key={tagIndex}>{tag.tag_name}</li>
                                                                ))
                                                            ) : (
                                                                <li>No tags available</li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </Link>
                                            ))}
                                        </Slider>
                                    ) : null

                                )
                            ) : (
                                isLoading ? (
                                    <Spinner3 />
                                ) : (
                                    category?.blogs_data ? (
                                        <Slider {...homeSlider1} className='homeslider responsive_home_slider'>
                                            {category.blogs_data.map((item, index) => (
                                                <Link to='/Comment' className='Category_card' key={index}>
                                                    <img src={item?.thumbnail_image} alt={item.title} />
                                                    <div className='Category_card_post_flex'>
                                                        <div className='Category_img_grid'>
                                                            <img src={item?.userprofile} alt={`${item.username}'s profile`} />
                                                        </div>
                                                        <div>
                                                            <h2>{item.title}</h2>
                                                            <p>
                                                                <span>{item.username}</span>
                                                                <span>{item.view_count} views</span>
                                                            </p>
                                                        </div>
                                                        <ul>
                                                            {item.tags.length > 0 ? (
                                                                item.tags.map((tag, tagIndex) => (
                                                                    <li key={tagIndex}>{tag.tag_name}</li>
                                                                ))
                                                            ) : (
                                                                <li>No tags available</li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </Link>
                                            ))}
                                        </Slider>
                                    ) : null

                                )
                            )}
                        </div>
                    </div>
                ))}
            </div >


            {/* <div className='Featured_Category'>
                {homeCategryList?.cat_data.map((category, categoryIndex) => (
                    <div key={categoryIndex}>
                        <div className='Featured_Category_heading_flex'>
                            <div>
                                <h2>{category.name}</h2>
                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
                            </div>
                            <div>
                                <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER }}>
                                    <span>View all</span>
                                    <FaArrowRightLong />
                                </button>
                            </div>
                        </div>
                        <div className='Featured_Category_grid'>
                            <Slider {...homeSlider1}>
                                {category.blogs_data.map((item, index) => (
                                    <div className='Category_card' key={index}>
                                        <img src={item?.thumbnail_image} alt={item.title} />
                                        <div className='Category_card_post_flex'>
                                            <div className='Category_img_grid'>
                                                <img src={item?.userprofile} alt={`${item.username}'s profile`} />
                                            </div>
                                            <div>
                                                <h2>{item.title}</h2>
                                                <p>
                                                    <span>{item.username}</span>
                                                    <span>{item.view_count}</span>
                                                </p>
                                            </div>
                                            <ul>
                                                {item.tags.length > 0 ? (
                                                    item.tags.map((tag, tagIndex) => (
                                                        <li key={tagIndex}>{tag.tag_name}</li>
                                                    ))
                                                ) : (
                                                    <li>No tags available</li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                ))}
            </div> */}
            {/* 
            <Slider {...homeSlider1}>
                {homeCategryList?.cat_data[0].blogs_data.map((item, index) => (
                    <div className='Category_card' key={index}>
                        <img src={item?.thumbnail_image} />
                        <div className='Category_card_post_flex'>
                            <div className='Category_img_grid'>
                                <img src={item?.userprofile} />
                            </div>
                            <div>
                                <h2>{item.title}</h2>
                                <p>
                                    <span>{item.username}</span>
                                    <span>{item.view_count}</span>
                                </p>
                            </div>
                            <ul>
                                {item.tags.length > 0 ? (
                                    item.tags.map((tag, tagIndex) => (
                                        <li key={tagIndex}>{tag.tag_name}</li>
                                    ))
                                ) : (
                                    <li>No tags available</li>
                                )}
                            </ul>
                        </div>
                    </div>
                ))}
            </Slider> */}
        </>
    )
}

export default Home












// import React, { useEffect } from 'react'
// import { Colors } from '../color'
// import RightArrow from '../assets/images/right_arrow.png'
// import { FaArrowRightLong } from "react-icons/fa6";
// import Categories from '../components/Categories';
// import { Featured, Tranding } from '../constants/LocalData';
// import OwlSlider from '../view/customSlider';
// import { NavLink } from 'react-router-dom';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import { useDispatch, useSelector } from 'react-redux';
// import { getHomeData, getpostlist } from '../redux/actions/action-creator';

// const Home = () => {
//     const dispatch = useDispatch();

//     const { homeSliderList = [], homeCategryList = [] } = useSelector(state => state.common);

//     // console.log('======== Demo TAG ===========', homeCategryList?.cat_data[1].blogs_data?.tags)
//     useEffect(() => {
//         dispatch(getHomeData());
//         dispatch(getpostlist());
//     }, [])

//     const API_Function = () => {
//         // let formData = new FormData();

//         // dispatch(getHomeData()).then(response => {
//         //     if (response?.status) {
//         //     } else { }
//         // }).catch(error => {
//         // }).finally(() => {
//         //     // setScreenLoader(false);
//         // });


//     }

//     const heading_Featured = 'Featured Network'
//     const heading_Trending = 'Trending Network'
//     const homeSlider1 = {
//         dots: true,
//         infinite: false,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                     infinite: true,
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     initialSlide: 2
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 2,
//                 }
//             }
//         ]
//     };
//     const homeSlider2 = {
//         dots: true,
//         infinite: false,
//         speed: 500,
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                     infinite: true,
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     initialSlide: 2
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 2,
//                 }
//             }
//         ]
//     };
//     const homeSlider3 = {
//         dots: true,
//         infinite: false,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                     infinite: true,
//                 }
//             },
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     initialSlide: 2
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 2,
//                 }
//             }
//         ]
//     };


//     return (
//         <>
//             {/* <OwlSlider /> */}
//             {/* ///////////// Featured ///////////// */}
//             <div className='Featured_Category'>
//                 <div className='Featured_Category_heading_flex'>
//                     <div>
//                         <h2>{homeCategryList?.cat_data[0]?.name}</h2>
//                         <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
//                         <ul>
//                             {/* <li>{homeCategryList?.cat_data[0].blogs_data[0].tags}</li> */}
//                         </ul>
//                     </div>
//                     <div>
//                         <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER, }}>
//                             <span>View all</span>
//                             <FaArrowRightLong />
//                         </button>
//                     </div>
//                 </div>
//                 <div className='Featured_Category_grid'>
//                     <Slider {...homeSlider1}>
//                         {
//                             homeCategryList?.cat_data[0]?.blogs_data.map((item, index) => {
//                                 return (
//                                     <div className='Category_card' key={index}>
//                                         <img src={item?.thumbnail_image} />
//                                         <div className='Category_card_post_flex'>
//                                             <div className='Category_img_grid'>
//                                                 <img src={item?.userprofile} />
//                                             </div>
//                                             <div>
//                                                 <h2>{item.title}</h2>
//                                                 <p>
//                                                     <span>{item.username}</span>
//                                                     <span>{item.view_count}</span>
//                                                 </p>
//                                             </div>
//                                             <ul>
//                                                 {item.tags.length > 0 ? (
//                                                     item.tags.map((tag, tagIndex) => (
//                                                         <li key={tagIndex}>{tag.tag_name}</li>
//                                                     ))
//                                                 ) : (
//                                                     <li>No tags available</li>
//                                                 )}
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 );
//                             })
//                         }
//                     </Slider>
//                 </div>
//             </div>

//             {/* ///////////// Tranding ///////////// */}
//             <div className='Featured_Category Tranding'>
//                 <div className='Featured_Category_heading_flex'>
//                     <div>
//                         <h2>{homeCategryList?.cat_data[1].name}</h2>
//                         <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
//                     </div>
//                     <div>
//                         <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER, }}>
//                             <NavLink to='/Library   '>
//                                 <span>View all</span>
//                                 <FaArrowRightLong />
//                             </NavLink>
//                         </button>
//                     </div>
//                 </div>
//                 <div className='Featured_Category_grid'>
//                     <Slider {...homeSlider2}>
//                         {
//                             homeCategryList?.cat_data[1].blogs_data.map((item, index) => {
//                                 return (
//                                     <div className='Category_card' key={index}>
//                                         <img src={item?.thumbnail_image} />
//                                         <div className='Category_card_post_flex'>
//                                             <div className='Category_img_grid'>
//                                                 <img src={item?.userprofile} />
//                                             </div>
//                                             <div>
//                                                 <h2>{item.title}</h2>
//                                                 <p>
//                                                     <span>{item.username}</span>
//                                                     <span>{item.view_count}</span>
//                                                 </p>
//                                             </div>
//                                             <ul>
//                                                 {item.tags.map((tag, tagIndex) => (
//                                                     <li key={tagIndex}>{tag.tag_name}</li>
//                                                 ))}
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 );
//                             })
//                         }
//                     </Slider>
//                 </div>
//             </div>

//             {/* ///////////// Featured ///////////// */}
//             <div className='Featured_Category' style={{ border: 'none' }}>
//                 <div className='Featured_Category_heading_flex'>
//                     <div>
//                         <h2>{homeCategryList?.cat_data[2].name}</h2>
//                         <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
//                     </div>
//                     <div>
//                         <button className='Button' style={{ color: Colors.TEXT_DARK, backgroundColor: Colors.BACKGROUND_PRIMER, }}>
//                             <span>View all</span>
//                             <FaArrowRightLong />
//                         </button>
//                     </div>
//                 </div>
//                 <div className='Featured_Category_grid'>
//                     <Slider {...homeSlider3}>
//                         {
//                             homeCategryList?.cat_data[2].blogs_data.map((item, index) => {
//                                 return (
//                                     <div className='Category_card' key={index}>
//                                         <img src={item?.thumbnail_image} />
//                                         <div className='Category_card_post_flex'>
//                                             <div className='Category_img_grid'>
//                                                 <img src={item?.userprofile} />
//                                             </div>
//                                             <div>
//                                                 <h2>{item.title}</h2>
//                                                 <p>
//                                                     <span>{item.username}</span>
//                                                     <span>{item.view_count}</span>
//                                                 </p>
//                                             </div>
//                                             <ul>
//                                                 {item.tags.map((tag, tagIndex) => (
//                                                     <li key={tagIndex}>{tag.tag_name}</li>
//                                                 ))}
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 );
//                             })
//                         }
//                     </Slider>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default Home